import jbs_api from "@/modules/jbs-api";

export default {
    namespaced: true,
    state: {
        items: {},
        loading: false
    },
    getters: {
        is_product_in_list: state => sku => {
            if (typeof (state.items.find) === 'undefined') {
                return false;
            }
            return state.items.find((item) => item.item_code === sku)
        },
        get_items: state => {
            return state.items;
        },
        is_loading: state => {
            return state.loading;
        }
    },
    mutations: {
        update(state, payload) {
            if (payload === false) {
                state.items = {};
            }
            state.items = payload.items;
        },
        set_loading(state, payload) {
            state.loading = payload;
        }
    },
    actions: {
        add_item(context, payload) {
            context.commit('set_loading', true);
            return jbs_api
                .put("WishList", { sku: payload })
                .then(response => {
                    context.commit("update", response.state);
                }).finally(() => {
                    context.commit('set_loading', false);
                });
        },
        remove_item(context, payload) {
            context.commit('set_loading', true);
            return jbs_api
                .delete("WishList", { params: { sku: payload } })
                .then(response => {
                    context.commit("update", response.state);
                }).finally(() => {
                    context.commit('set_loading', false);
                });
        },
    }
};
